import React from "react";

export function LocationMap() {
  const googleMapsLink = "https://maps.app.goo.gl/j6oiBeNz7pWcXKxD9?g_st=iw";
  
  return (
    <div className="w-full h-full flex flex-col">
      {/* Map Thumbnail */}
      <div className="flex-1 relative rounded-t-lg overflow-hidden" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 200'%3E%3Cdefs%3E%3Cpattern id='grid' width='20' height='20' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 20 0 L 0 0 0 20' fill='none' stroke='%23e5e7eb' stroke-width='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='400' height='200' fill='%23f8fafc'/%3E%3Crect width='400' height='200' fill='url(%23grid)'/%3E%3Cpath d='M50 120 Q100 100 150 120 T250 120 Q300 110 350 120' stroke='%2393c5fd' stroke-width='3' fill='none'/%3E%3Cpath d='M80 80 L120 80 L120 120 L80 120 Z' fill='%23dcfce7'/%3E%3Cpath d='M200 60 L240 60 L240 100 L200 100 Z' fill='%23dcfce7'/%3E%3Cpath d='M280 90 L320 90 L320 130 L280 130 Z' fill='%23dcfce7'/%3E%3Cpath d='M30 40 L70 40 L50 20 Z' fill='%23fef3c7'/%3E%3Cpath d='M320 40 L360 40 L340 20 Z' fill='%23fef3c7'/%3E%3Cpath d='M200 100c-16.569 0-30 13.431-30 30 0 26.25 30 60 30 60s30-33.75 30-60c0-16.569-13.431-30-30-30zm0 41.25c-6.213 0-11.25-5.037-11.25-11.25s5.037-11.25 11.25-11.25 11.25 5.037 11.25 11.25-5.037 11.25-11.25 11.25z' fill='%23D7263D'/%3E%3Ctext x='200' y='200' text-anchor='middle' fill='%23374151' font-family='Arial' font-size='10' font-weight='600'%3EShree Mahalaxmi Food Products%3C/text%3E%3C/svg%3E")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>

        {/* Overlay for click interaction */}
        <a
          href={googleMapsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors duration-200 flex items-center justify-center group"
        >
          <div className="bg-white/90 rounded-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <svg className="w-6 h-6 text-[#D7263D]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </div>
        </a>
      </div>
      
      {/* View on Google Maps Button */}
      <div className="p-2">
        <a
          href={googleMapsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full inline-flex items-center justify-center gap-2 bg-[#D7263D] hover:bg-[#FF6B35] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
          View on Google Maps
        </a>
      </div>
    </div>
  );
}
